import { configureStore } from "@reduxjs/toolkit";
import recentTransactionsReducer from "../features/recentTransactions/recentTransactionSlice";
import filterTransactionsReducer from "../features/filterTransactions/filterTransactionSlice";

export const store = configureStore({
  reducer: {
    recentTransactions: recentTransactionsReducer,
    filterTransactions: filterTransactionsReducer,
  },
});
